export { default as SalesResumeStats } from "./stats";
export { default as SalesResumeAbout } from "./about";
export { default as SalesResumeProfile } from "./profile";
export {
  default as SalesResumeExperience,
  SalesResumeCampaignStats,
} from "./experience";
export { default as SalesResumeIndustry } from "./industry";
